import React from "react";

const BreadcrumbsWrapper = ({children}) => {
    return (
        <nav className="breadcrumbs">
            {children}
        </nav>
    )
}

export default BreadcrumbsWrapper;